import {useQuery} from '@tanstack/react-query'
import {api} from '@/lib/api'
import {base} from '@/hooks/bateria/use-bateria'
import type {components} from '@/lib/api-schema'

export type RecorteAlVuelo = components['schemas']['RecorteRead']

/** Compartida con la precarga (`use-precarga-cortes.ts`) para que lo precargado sirva a la tarjeta. */
export function claveDeRecorte(
  businessId: string,
  evaluacionId: string,
  paqueteId: string | null,
  itemId: string | null
) {
  return ['bateria-recorte-al-vuelo', businessId, evaluacionId, paqueteId, itemId]
}

export async function pedirRecorte(
  businessId: string,
  evaluacionId: string,
  paqueteId: string,
  itemId: string
): Promise<RecorteAlVuelo> {
  const url = `${base(businessId)}/evaluaciones/${evaluacionId}/paquetes/${paqueteId}/items/${itemId}/recorte`
  return (await api.get<RecorteAlVuelo>(url)).data
}

/** Aparte de la tarjeta: cortar cuesta ~65 ms (medido). `retry: false` porque el 404 es legítimo: la fila no
 * se puede cortar. */
export function useRecorteAlVuelo(
  businessId: string,
  evaluacionId: string,
  paqueteId: string | null,
  itemId: string | null,
  habilitado: boolean
) {
  return useQuery({
    queryKey: claveDeRecorte(businessId, evaluacionId, paqueteId, itemId),
    // `enabled` ya exige que no sean nulos; react-query no lo expresa en el tipo.
    queryFn: () => pedirRecorte(businessId, evaluacionId, paqueteId!, itemId!),
    enabled: habilitado && businessId !== '' && evaluacionId !== '' && paqueteId !== null && itemId !== null,
    staleTime: Infinity,
    retry: false,
  })
}
